import { create } from "zustand";

interface AppState {
  mobileMenuOpened: boolean;
  toggleMobileMenu: () => void;

  cartOpened: boolean;
  toggleCart: () => void;

  bookNowOpened: boolean;
  toggleBookNow: () => void;

  authModalOpened: boolean;
  authModalType: "login" | "signup" | null;
  authModalFrom: string | null;
  authModalBlocked: boolean;
  openAuthModal: (type: "login" | "signup", from?: string, blocked?: boolean) => void;
  closeAuthModal: () => void;
  resetAuthModal: () => void;
}

export const useAppStore = create<AppState>((set) => ({
  mobileMenuOpened: false,
  toggleMobileMenu: () =>
    set((state) => ({ mobileMenuOpened: !state.mobileMenuOpened })),
  cartOpened: false,
  toggleCart: () => set((state) => ({ cartOpened: !state.cartOpened })),
  bookNowOpened: false,
  toggleBookNow: () =>
    set((state) => ({ bookNowOpened: !state.bookNowOpened })),
  authModalOpened: false,
  authModalType: null,
  authModalFrom: null,
  authModalBlocked: false,
  openAuthModal: (type: "login" | "signup", from?: string, blocked?: boolean) =>
    set({
      authModalOpened: true,
      authModalType: type,
      authModalFrom: from || null,
      authModalBlocked: blocked || false,
    }),
  resetAuthModal: () =>
    set({
      authModalType: null,
      authModalFrom: null,
      authModalBlocked: false,
    }),
  closeAuthModal: () =>
    set((state) => {
      if (state.authModalBlocked) {
        return state;
      }
      return {
        authModalOpened: false,
      };
    }),
}));
